import { downLoadInvoice, getAllInvoices, getAllInvoicesForDownload, typesAndStatus, sendInvoiceEmail, initiateRefund, getRefundsByTicketId, getRefundsByOrderRefId, syncRefundStatus, downloadRefundCreditNote } from "../../Http/Index";

export const getAllInvoicesAction = async ({ page, limit, type, paymentStatus, startDate, endDate, ticketId }: {
    page: number;
    limit: number;
    type?: string;
    paymentStatus?: string;
    startDate?: string;
    endDate?: string;
    ticketId?: string;
}) => {
    try {
        let query = `page=${page}&limit=${limit}`;
        if (type) query += `&type=${type}`;
        if (paymentStatus) query += `&paymentStatus=${paymentStatus}`;
        if (startDate) query += `&startDate=${startDate}`;
        if (endDate) query += `&endDate=${endDate}`;
        if (ticketId) query += `&ticketId=${ticketId}`;

        const response = await getAllInvoices(query);
        return { status: true, data: response.data }
    } catch (error: any) {
        return { status: false, message: error?.response?.message || "Failed to fetch invoices" }
    }
}

export const getAllInvoicesForDownloadAction = async ({ page, limit, type, paymentStatus, startDate, endDate, ticketId }: {
    page: number;
    limit: number;
    type?: string;
    paymentStatus?: string;
    startDate?: string;
    endDate?: string;
    ticketId?: string;
}) => {
    try {
        let query = `page=${page}&limit=${limit}`;
        if (type) query += `&type=${type}`;
        if (paymentStatus) query += `&paymentStatus=${paymentStatus}`;
        if (startDate) query += `&startDate=${startDate}`;
        if (endDate) query += `&endDate=${endDate}`;
        if (ticketId) query += `&ticketId=${ticketId}`;
        const response = await getAllInvoicesForDownload(query);
        return { status: true, data: response }
    } catch (error: any) {
        return { status: false, message: error?.response?.data?.message || "Unauthorized or failed to download invoices" }
    }
}

export const downLoadInvoiceAction = async (invoiceId: string): Promise<any> => {
    try {
        const response = await downLoadInvoice(invoiceId)
        return { status: true, data: response }

    } catch (error: any) {
        return { status: false, message: error?.response?.message || "Failed to download invoice" }
    }
}
export const getTypesAndStatusAction = async () => {
    try {
        const response = await typesAndStatus();
        return { status: true, data: response.data.data }
    } catch (error: any) {
        return { status: false, message: error?.response?.message || "Failed to fetch types" }
    }
}

export const sendInvoiceEmailAction = async (invoiceId: string, email: string) => {
    try {
        const response = await sendInvoiceEmail(invoiceId, email);
        return { status: true, message: response.data.message }
    } catch (error: any) {
        return { status: false, message: error?.response?.data?.message || "Failed to send invoice email" }
    }
}

// export const downLoadBulkInvoicesAction = async (pocoOrderIds: string[]): Promise<any> => {
//     try {
//         const response = await downLoadBulkInvoices({ pocoOrderIds })
//         return { status: true, data: response }
//     } catch (error: any) {
//         return { status: false, message: error?.response?.message || "Failed to download bulk invoices" }
//     }
// }


export const initiateRefundAction = async (payload: { order_ref_id: string; amount?: number; reason?: string }) => {
    try {
        const response = await initiateRefund(payload);
        return { status: true, data: response.data };
    } catch (error: any) {
        return {
            status: false,
            message: error?.response?.data?.message || error?.message || "Failed to initiate refund",
        };
    }
};

export const getRefundsByTicketIdAction = async (ticketId: string) => {
    try {
        const response = await getRefundsByTicketId(ticketId);
        return { status: true, data: response.data };
    } catch (error: any) {
        return {
            status: false,
            message: error?.response?.data?.message || error?.message || "Failed to fetch refunds",
        };
    }
};

export const getRefundsByOrderRefIdAction = async (orderRefId: string) => {
    try {
        const response = await getRefundsByOrderRefId(orderRefId);
        return { status: true, data: response.data };
    } catch (error: any) {
        return {
            status: false,
            message: error?.response?.data?.message || error?.message || "Failed to fetch refunds",
        };
    }
};

export const syncRefundStatusAction = async (refundId: string) => {
    try {
        const response = await syncRefundStatus(refundId);
        return { status: true, data: response.data };
    } catch (error: any) {
        return {
            status: false,
            message: error?.response?.data?.message || error?.message || "Failed to sync refund status",
        };
    }
};

export const downloadRefundCreditNoteAction = async (refundId: string): Promise<any> => {
    try {
        const response = await downloadRefundCreditNote(refundId);
        return { status: true, data: response };
    } catch (error: any) {
        return {
            status: false,
            message: error?.response?.data?.message || error?.message || "Failed to download refund credit note",
        };
    }
};
